export const SITE = {
  name: "Cheap Cars in Spain",
  address: "Camino Viejo de Coín 91, 29651 Mijas (Málaga)",
  phone: "+34 670 575 626",
  whatsappNumber: "34670575626",
  mapEmbedSrc:
    "https://www.google.com/maps?q=" +
    encodeURIComponent("Camino Viejo de Coin 91, 29651 Mijas, Malaga, Spain") +
    "&output=embed",
};

export function whatsappLink(message) {
  return `https://wa.me/${SITE.whatsappNumber}?text=${encodeURIComponent(message)}`;
}
